export default "__VITE_ASSET__bf0a493d__"